/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/homePage/commonUtil.js
*    TO   --> ./webapps/homepage-web/src/main/assets/js/home/award-finder/common-util.js
**/

var CommonUtil = {};

CommonUtil = (function() {

	var $_form = undefined;

	function storeFormData($form) {
		$_form = $('<form></form>');
		$form.find('input').clone().appendTo($_form);
		$form.find('select').each(function() {
			$_form.append($('<input>').attr({
				type: 'hidden',
				name: $(this).attr('name'),
				value: $(this).find('option:selected').val()
			}));
		});

//		$_form = $form.clone();
	}

	function getForm() {
		return $_form;
	}

	/*
	 * generates query string to link into the booking flow
	 * the query string does not include the initial '?'
	 */
	function generateQueryStringForBooking(destination) {
		$_form.find('input[name="destination"]').val(destination);
		return '/awardMap/book?' + WebAnalytics.addWebAnalyticsFieldsAndSerialize($_form);
	}

	/*
     * if logged in, returns true if miles is higher than
     * number of miles the user has.
     * If not logged in, returns true
     */
    function milesMoreThanUserHas(miles) {
    	var txt = $('#aadvMiles').text();
    	if(txt !== '') { // user logged in, has miles
    		var milesNumber = +txt.replace(/,/g, ''); // strip commas
    		if(!isNaN(milesNumber)) {
    			return miles > milesNumber;
    		}
    	}
    	return true;

    }

    /*
     * determines whether to display 'buy miles' on
     *  the list and map results (as opposed to book now)
     * 'buy miles' is displayed when user does not
     * have enough miles to book a trip or if miles
     * more than search when user is not logged in
     */
    function displayBuyMiles(miles, upshow) {
    	var loggedIn = userLoggedIn();
		return (loggedIn && CommonUtil.milesMoreThanUserHas(miles)) || (!loggedIn && upshow);
    }

    function userLoggedIn() {
    	return ($.trim($('#aadvMiles').text()).length>1);
    }

    function hideBackToAllResultsLink() {
    	$('#showAllResults').hide().removeClass('has-searched');
    }

    function showBackToAllResultsLink() {
    	var $zoomToAllDiv = $('#showAllResults');
    	if($zoomToAllDiv.hasClass('has-searched')) {
    		$zoomToAllDiv.show();
    	}
    }

	/*
	 * input: number or string without commas
	 * output: string with thousands-separator commas
	 * if an error occurs, returns input
	 */
    function commaSeparateNumber(val){
    	var ret = val;
        while (/(\d+)(\d{3})/.test(ret.toString())){
          ret = ret.toString().replace(/(\d+)(\d{3})/, '$1'+','+'$2');
        }
        ret = (ret == undefined || ret == null || ret == "") ? val : ret;
        return ret;
      }

	return {
		storeFormData : storeFormData,
		generateQueryStringForBooking : generateQueryStringForBooking,
		getForm : getForm,
		milesMoreThanUserHas : milesMoreThanUserHas,
		hideBackToAllResultsLink : hideBackToAllResultsLink,
		showBackToAllResultsLink : showBackToAllResultsLink,
		displayBuyMiles : displayBuyMiles,
		commaSeparateNumber : commaSeparateNumber
	};

}());
